module.exports = __webpack_public_path__ + "media/info-item-2.a5089a58.mp4";